import { MetricFormat } from 'constants/scorecards';
import { formatCurrency } from 'helpers';

export const formatMetricValue = (
  val: string | number,
  format?: MetricFormat,
) => {
  if (!val) return '';
  if (!format) return val;

  switch (format) {
    case MetricFormat.PERCENTAGE:
      return `${val}%`;
    case MetricFormat.CURRENCY:
      return `$${formatCurrency(val)}`;
    default:
      return val;
  }
};
